module.exports = __webpack_public_path__ + "static/media/group-33@2x.abbc2b21.png";